/**
 * Servicio de batería
 * Sprint 7 - HU-FE-01: Captura de nivel de batería del dispositivo
 *
 * Usa la Battery Status API (navigator.getBattery) cuando está disponible.
 * Retorna null si la API no está soportada (ej. iOS Safari).
 */

interface BatteryManager {
    level: number; // 0.0 - 1.0
    charging: boolean;
    chargingTime: number;
    dischargingTime: number;
    addEventListener: (type: string, listener: EventListener) => void;
    removeEventListener: (type: string, listener: EventListener) => void;
}

/**
 * Obtiene el nivel de batería actual como porcentaje entero (0-100).
 * Retorna null si la Battery API no está disponible.
 */
export async function getBatteryLevel(): Promise<number | null> {
    try {
        if (!('getBattery' in navigator)) {
            return null;
        }

        const battery = await (navigator as Navigator & { getBattery: () => Promise<BatteryManager> }).getBattery();
        return Math.round(battery.level * 100);
    } catch {
        console.warn('[Battery] API not available');
        return null;
    }
}

export const batteryService = {
    getBatteryLevel,
};
